import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// 会員登録
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import AgentAuthComplete from '../../components/pages/agent/AgentAuthComplete';
import AgentAuthSent from '../../components/pages/agent/AgentAuthSent';
import AgentClientRegisterBasic from '../../components/pages/agent/AgentClientRegisterBasic';
import AgentClientRegisterCompany from '../../components/pages/agent/AgentClientRegisterCompany';
import AgentInTransaction from '../../components/pages/agent/AgentInTransaction';
import AgentIssueDetail from '../../components/pages/agent/AgentIssueDetail';
import AgentMessageList from '../../components/pages/agent/AgentMessageList';
import AgentMypage from '../../components/pages/agent/AgentMypage';
import AgentMypageFavoriteMediaList from '../../components/pages/agent/AgentMypageFavoriteMediaList';
import AgentMypageInfoEdit from '../../components/pages/agent/AgentMypageInfoEdit';
import AgentMypageIssueComplete from '../../components/pages/agent/AgentMypageIssueComplete';
import AgentMypageIssueEdit from '../../components/pages/agent/AgentMypageIssueEdit';
import AgentMypageIssueList from '../../components/pages/agent/AgentMypageIssueList';
import AgentMypageMedia from '../../components/pages/agent/AgentMypageMedia';
import AgentMypageMediaArticle from '../../components/pages/agent/AgentMypageMediaArticle';
import AgentMypageMediaCompare from '../../components/pages/agent/AgentMypageMediaCompare';
import AgentMypageMediaDetail from '../../components/pages/agent/AgentMypageMediaDetail';
import AgentMypageMessageDetail from '../../components/pages/agent/AgentMypageMessageDetail';
import AgentMypageNewsDetail from '../../components/pages/agent/AgentMypageNewsDetail';
import AgentMypageNewsList from '../../components/pages/agent/AgentMypageNewsList';
import AgentMypageOrientationEdit from '../../components/pages/agent/AgentMypageOrientationEdit';
import AgentMypageStaffDeleteComplete from '../../components/pages/agent/AgentMypageStaffDeleteComplete';
import AgentMypageStaffEdit from '../../components/pages/agent/AgentMypageStaffEdit';
import AgentMypageStaffInvite from '../../components/pages/agent/AgentMypageStaffInvite';
import AgentMypageStaffInviteComplete from '../../components/pages/agent/AgentMypageStaffInviteComplete';
import AgentRegister from '../../components/pages/agent/AgentRegister';
import AgentRegisterBasic from '../../components/pages/agent/AgentRegisterBasic';
import AgentRegisterCompany from '../../components/pages/agent/AgentRegisterCompany';
import AgentRegisterInfo from '../../components/pages/agent/AgentRegisterInfo';
import AgentStaffList from '../../components/pages/agent/AgentStaffList';
import ClientAuthComplete from '../../components/pages/client/ClientAuthComplete';
import ClientAuthSent from '../../components/pages/client/ClientAuthSent';
import ClientMessageList from '../../components/pages/client/ClientMessageList';
import ClientMypage from '../../components/pages/client/ClientMypage';
import ClientMypageCompanyEdit from '../../components/pages/client/ClientMypageCompanyEdit';
import ClientMypageFavoriteMediaList from '../../components/pages/client/ClientMypageFavoriteMediaList';
import ClientMypageIssueComplete from '../../components/pages/client/ClientMypageIssueComplete';
import ClientMypageIssueEdit from '../../components/pages/client/ClientMypageIssueEdit';
import GivenList from '../../components/pages/client/ClientMypageIssueList';
import ClientMypageMedia from '../../components/pages/client/ClientMypageMedia';
import ClientMypageMediaArticle from '../../components/pages/client/ClientMypageMediaArticle';
import ClientMypageMediaCompare from '../../components/pages/client/ClientMypageMediaCompare';
import ClientMypageMediaDetail from '../../components/pages/client/ClientMypageMediaDetail';
import ClientMypageMessageDetail from '../../components/pages/client/ClientMypageMessageDetail';
import ClientMypageNewsDetail from '../../components/pages/client/ClientMypageNewsDetail';
import ClientMypageNewsList from '../../components/pages/client/ClientMypageNewsList';
import ClientMypageOrientationEdit from '../../components/pages/client/ClientMypageOrientationEdit';
import ClientMypageStaffDeleteComplete from '../../components/pages/client/ClientMypageStaffDeleteComplete';
import ClientMypageStaffEdit from '../../components/pages/client/ClientMypageStaffEdit';
import ClientMypageStaffInvite from '../../components/pages/client/ClientMypageStaffInvite';
import ClientMypageStaffInviteComplete from '../../components/pages/client/ClientMypageStaffInviteComplete';
import ClientRegister from '../../components/pages/client/ClientRegister';
import ClientRegisterBasic from '../../components/pages/client/ClientRegisterBasic';
import ClientRegisterCompany from '../../components/pages/client/ClientRegisterCompany';
import ClientRegisterInfo from '../../components/pages/client/ClientRegisterInfo';
import ClientRegisterIssue from '../../components/pages/client/ClientRegisterIssue';
import ClientRegisterOrientation from '../../components/pages/client/ClientRegisterOrientation';
import ClientStaffList from '../../components/pages/client/ClientStaffList';
import Action from '../../components/pages/common/Action';
import ClientTerm from '../../components/pages/common/ClientTerm';
import Login from '../../components/pages/common/Login';
import MediaTerm from '../../components/pages/common/MediaTerm';
import PasswordChange from '../../components/pages/common/PasswordChange';
import PasswordComplete from '../../components/pages/common/PasswordComplete';
import PasswordReset from '../../components/pages/common/PasswordReset';
import PasswordRestSendmail from '../../components/pages/common/PasswordRestSendmail';
import Privacy from '../../components/pages/common/Privacy';
import StaffInviteComplete from '../../components/pages/common/StaffInviteComplete';
import StaffRegister from '../../components/pages/common/StaffRegister';
import Contact from '../../components/pages/contact/Contact';
import ContactComplete from '../../components/pages/contact/ContactComplete';
import ContactConfirm from '../../components/pages/contact/ContactConfirm';
import PublisherAuthComplete from '../../components/pages/publisher/PublisherAuthComplete';
import PublisherAuthSent from '../../components/pages/publisher/PublisherAuthSent';
import PublisherIssueDetail from '../../components/pages/publisher/PublisherIssueDetail';
import PublisherMediaRegisterCaseEdit from '../../components/pages/publisher/PublisherMediaRegisterCaseEdit';
import PublisherMediaRegisterComplete from '../../components/pages/publisher/PublisherMediaRegisterComplete';
import PublisherMediaRegisterEdit from '../../components/pages/publisher/PublisherMediaRegisterEdit';
import PublisherMediaRegisterService from '../../components/pages/publisher/PublisherMediaRegisterService';
import PublisherMediaUserInfoRegisterEdit from '../../components/pages/publisher/PublisherMediaUserInfoRegisterEdit';
import PublisherMessageList from '../../components/pages/publisher/PublisherMessageList';
import PublisherMypage from '../../components/pages/publisher/PublisherMypage';
import PublisherMypageArticle from '../../components/pages/publisher/PublisherMypageArticle';
import PublisherMypageArticleEdit from '../../components/pages/publisher/PublisherMypageArticleEdit';
import PublisherMypageArticlePreview from '../../components/pages/publisher/PublisherMypageArticlePreview';
import PublisherMypageFavoriteList from '../../components/pages/publisher/PublisherMypageFavoriteList';
import PublisherMypageInfoEdit from '../../components/pages/publisher/PublisherMypageInfoEdit';
import PublisherMypageIssueList from '../../components/pages/publisher/PublisherMypageIssueList';
import PublisherMypageMedia from '../../components/pages/publisher/PublisherMypageMedia';
import PublisherMypageMediaDetail from '../../components/pages/publisher/PublisherMypageMediaDetail';
import PublisherMypageMessageDetail from '../../components/pages/publisher/PublisherMypageMessageDetail';
import PublisherMypageNewsDetail from '../../components/pages/publisher/PublisherMypageNewsDetail';
import PublisherMypageNewsList from '../../components/pages/publisher/PublisherMypageNewsList';
import PublisherMypageStaffDeleteComplete from '../../components/pages/publisher/PublisherMypageStaffDeleteComplete';
import PublisherMypageStaffEdit from '../../components/pages/publisher/PublisherMypageStaffEdit';
import PublisherMypageStaffInvite from '../../components/pages/publisher/PublisherMypageStaffInvite';
import PublisherMypageStaffInviteComplete from '../../components/pages/publisher/PublisherMypageStaffInviteComplete';
import PublisherRegister from '../../components/pages/publisher/PublisherRegister';
import PublisherRegisterBasic from '../../components/pages/publisher/PublisherRegisterBasic';
import PublisherRegistrationInfo from '../../components/pages/publisher/PublisherRegistrationInfo';
import PublisherStaffList from '../../components/pages/publisher/PublisherStaffList';
import { AuthProvider } from '../../contexts/auth';
import { PrivateOutlet } from '../PrivateOutlet';
import { TypeOutlet } from '../TypeOutlet';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0
});

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const RoutesIndex: React.FC = () => (
  <BrowserRouter basename="/main/">
    <AuthProvider>
      <SentryRoutes>
        <Route path={`/action`} element={<Action />} />
        <Route path={`/auth/login`} element={<Login />} />
        <Route path={`/auth/password_reset`} element={<PasswordReset />} />
        <Route
          path={`/auth/password_reset_complete`}
          element={<PasswordRestSendmail />}
        />
        <Route path={`/auth/password_change`} element={<PasswordChange />} />
        <Route
          path={`/auth/password/complete`}
          element={<PasswordComplete />}
        />
        <Route
          path={`/publisher/auth/register`}
          element={<PublisherRegister />}
        />
        <Route path={`/agent/auth/register`} element={<AgentRegister />} />
        <Route
          path={`/agent/mypage/company`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentRegisterInfo />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/company/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageInfoEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/staff/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageStaffEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/staff/invite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageStaffInvite />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/staff/invite/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageStaffInviteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/staff/delete/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageStaffDeleteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/staff/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageStaffEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/staff/invite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageStaffInvite />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/staff/invite/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageStaffInviteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/staff/delete/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageStaffDeleteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route path={`/auth/invite/register`} element={<StaffRegister />} />
        <Route
          path={`/publisher/mypage/issue`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageIssueList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/issue/favorite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageFavoriteList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/client`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentInTransaction />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/company`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientRegisterInfo />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/company/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageCompanyEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/issue`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <GivenList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/client/mypage/staff'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientStaffList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/client/mypage/message/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageMessageDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/client/mypage/message'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMessageList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/client/mypage/news'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageNewsList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/client/mypage/news/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageNewsDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/publisher/mypage/staff'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherStaffList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/publisher/mypage/message/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageMessageDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/publisher/mypage/message'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMessageList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        {/* 仮のURL */}
        <Route
          path={'/publisher/mypage/issue/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherIssueDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/publisher/mypage/news'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageNewsList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/publisher/mypage/news/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageNewsDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route path={`/client/auth/register`} element={<ClientRegister />} />
        <Route
          path={`/client/auth/company`}
          element={<ClientRegisterCompany />}
        />
        <Route path={`/client/auth/basic`} element={<ClientRegisterBasic />} />
        <Route path={`/client/auth/issue`} element={<ClientRegisterIssue />} />
        <Route
          path={`/publisher/mypage`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypage />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/auth/invite/register/complete`}
          element={<StaffInviteComplete />}
        />
        <Route path={`/agent/auth/basic`} element={<AgentRegisterBasic />} />
        <Route
          path={`/agent/client/company`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentClientRegisterCompany />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/client/basic`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentClientRegisterBasic />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/auth/basic`}
          element={<PublisherRegisterBasic />}
        />
        <Route
          path={`/client/auth/orientation`}
          element={<ClientRegisterOrientation />}
        />
        <Route
          path={`/client/mypage/issue/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageIssueEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/orientation/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageOrientationEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypage />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/media`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageMedia />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/media/favorite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageFavoriteMediaList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/article/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageMediaArticle />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/media/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageMediaDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/media/compare`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageMediaCompare />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypage />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/issue`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageIssueList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/issue/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageIssueEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/issue/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentIssueDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/orientation/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageOrientationEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/staff/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageStaffEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/message'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMessageList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/message/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageMessageDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/news'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageNewsList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/staff/invite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageStaffInvite />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/news/:id'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageNewsDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/staff/invite/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageStaffInviteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/staff/delete/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageStaffDeleteComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={'/agent/mypage/staff'}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentStaffList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/media`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageMedia />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/media/compare`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageMediaCompare />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/media/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageMediaDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/article/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageMediaArticle />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/media/favorite`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageFavoriteMediaList />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/client/mypage/issue/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <ClientMypageIssueComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/agent/mypage/issue/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <AgentMypageIssueComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/company`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherRegistrationInfo />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`/publisher/mypage/company/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageInfoEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route path={`/publisher/auth/sent`} element={<PublisherAuthSent />} />
        <Route path={`/client/auth/sent`} element={<ClientAuthSent />} />
        <Route path={`/client/auth/mypage/issue`} element={<GivenList />} />
        <Route path={`/agent/auth/sent`} element={<AgentAuthSent />} />
        <Route
          path={`/agent/auth/company`}
          element={<AgentRegisterCompany />}
        />
        <Route
          path={`/publisher/auth/complete`}
          element={<PublisherAuthComplete />}
        />
        <Route
          path={`/client/auth/complete`}
          element={<ClientAuthComplete />}
        />
        <Route path={`/agent/auth/complete`} element={<AgentAuthComplete />} />
        <Route
          path={`publisher/mypage/media`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageMedia />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageMediaDetail />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/article`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageArticle />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/article/edit`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageArticleEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/article/edit/:id`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMypageArticleEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/article/preview/:id`}
          element={<PublisherMypageArticlePreview />}
        />
        <Route
          path={`publisher/mypage/media/create`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaRegisterEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/:id/edit1`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaRegisterEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/:id/edit2`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaUserInfoRegisterEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/:id/edit3`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaRegisterService />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/:id/edit4`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaRegisterCaseEdit />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route
          path={`publisher/mypage/media/complete`}
          element={
            <PrivateOutlet>
              <TypeOutlet>
                <PublisherMediaRegisterComplete />
              </TypeOutlet>
            </PrivateOutlet>
          }
        />
        <Route path={`/common/contact`} element={<Contact />} />
        <Route path={`/common/contact_confirm`} element={<ContactConfirm />} />
        <Route
          path={`/common/contact_confirm_complete`}
          element={<ContactComplete />}
        />
        <Route path={`common/privacy`} element={<Privacy />} />
        <Route path={`common/client_term`} element={<ClientTerm />} />
        <Route path={`common/media_term`} element={<MediaTerm />} />
      </SentryRoutes>
    </AuthProvider>
  </BrowserRouter>
);

export default RoutesIndex;
